updateInternalState